<template>
  <div style="padding: 30px">
    <div style="display: flex">
      <el-select v-model="project_id" placeholder="请选择" class="marginL2" @change="handleChangeProject">
        <el-option
          v-for="item in projectList"
          :key="item.project_id"
          :label="item.project_name_cn"
          :value="item.project_id"
        >
        </el-option>
      </el-select>
      <el-select v-model="week_plan_id" placeholder="请选择" class="marginL2"  @change="handleChangeWeek" style="width:300px">
        <el-option
          v-for="item in weekplanList"
          :key="item.mgmt_plan_id"
          :label="
            item.plan_name + kong + '(' + item.begin_date + '-' + item.end_date + ')'
          "
          :value="item.mgmt_plan_id"
        >
        </el-option>
      </el-select>
      <el-button type="" icon="el-icon-plus" class="marginL2"
      @click="createdPlan"
        >新建计划</el-button
      >
      <div class="jindukuang marginL2">审核意见：{{progress}}</div>
    </div>
    <!-- 弹框 -->
    <el-dialog
      title="创建项目"
      :visible.sync="createdWeekPlan"
      width="60%"
      center
      style="font-size: 20px"
    >
      <div class="xianshikuang">
        <span class="lableName">周计划名称</span>
        <el-input placeholder="请输入周计划名称" v-model="week_plan_name">
        </el-input>
      </div>
    <div>
    <div class="xianshikuang mart3" >
    <span class="lableName">周计划时间段</span>
    <el-date-picker
      v-model="selectedriqi"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    </div>

  </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createdWeekPlan = false">取 消</el-button>
        <el-button type="primary" @click="weekPlanSrue">确 定</el-button>
      </span>
    </el-dialog>
    <div v-if="showWeekList && tableData.length > 0">
      <el-table
        row-key="mgmt_task_id"
        ref="table"
        class="table"
        :data="tableData"
        :span="24"      
        :row-style="{ height: '36px', padding: '8px 0' }"
        :header-row-style="{ height: '88px' }"
        :header-cell-style="{
          textAlign: 'center',
          padding: '4px 0',
          backgroundColor: '#fff',
          color: '#4c4c4c',
        }"
        @cell-click="cellclick"
        :cell-style="addClass"
        :span-method="objectSpanMethod"
        :cell-class-name="cellClassName" 
        @cell-mouse-enter.once='rowDrop'
        border
        height=700
        style="width: 100%; margin-top: 20px"
      >
     
    
        <el-table-column prop="" label="" width="30">
          <template slot-scope="scope">
            <div style="width:100%;height:100%;display:flex;">
                <div class="addBtn" @click="dianji(scope.row,scope)">+</div>
            </div>
           
          </template>
        </el-table-column>

        <el-table-column prop="depart_id" label="部门"  width="80">
          <template slot-scope="scope">
            <span class="taskName">{{ scope.row.depart_name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="阶段任务" width="220">
        <template slot-scope="scope" >
          <div class="selectKuang">
           <el-cascader
            size="small"
            style="width: 100%"
            v-model="scope.row.value1"
            :options="scope.row.chioes"
            :props="{ expandTrigger: 'hover' }"
            :show-all-levels="false"
            @change="changePahse(scope.$index,scope.row)"          
            :key="cascaderKey"
          ></el-cascader>
          </div>
    
           <!-- <div>{{ scope.row.task_name_str }}</div> -->
        </template>
      </el-table-column>
<!-- :width="isInputBlur?'130px':'80px'" -->
      <el-table-column prop="content" label="内容"  show-overflow-tooltip min-width="260">
              <template slot-scope="scope">
                <div class="inputDeep">
                  <el-input
                  ref="editInput"
                  v-model="scope.row.content" 
                  size="small"
                  type="textarea"
                  :rows="2"
                  @keydown.enter.native="carriageReturn($event,scope.row)"
                  @blur="inputBlur(scope.row)"  
                />
                <!-- <span v-else>{{ scope.row.content }}</span> -->
                </div>               
                
              </template>
      </el-table-column>

        <!-- <el-table-column prop="content" label="内容"  min-width="280px"> </el-table-column> -->
        <el-table-column
          v-for="(item, index) in weekDay"
          :prop="item.dayname"
          label="日期"
          :key="index"
          align="center"
          :index="index"
          width="26"
        >
      <template slot="header">
        <div class="daKuang">
        <div class="waiKuang">{{item.tian}}</div>
        <hr></hr>
        <div class="riqi">{{item.ri}}</div>
        <div class="yuefen">{{item.qi}}月</div>
      </div>             
      </template>
    </el-table-column>

       <el-table-column prop="project_company_id" label="完成人" width="210">
        <template slot-scope="scope">
          <div style="display: flex">
            <el-tag
              :key="index"
              v-for="(tag, index) in scope.row.roles_1"
              :disable-transitions="false"
              closable
              @close="handleClose(tag, scope.row)"
              style="margin-left:10px"
            >
              {{tag.employee_name_abbr}}
            </el-tag>

            <div>
              <el-input
                style="position: relative; display: block"
                class="input-new-tag"
                v-if="scope.row.edit"
                v-model="scope.row.zhanShi"
                ref="input1"
                size="small"
                @keyup.native="getHintsList(scope.row, $event)"
                @blur="shiqu(scope.row)"
              >
              </el-input>
              <div v-else class="tianjia" @click="showInput(scope.row)">+</div> 
              <div
                class="hintsBox"
                v-if="scope.row.showHintsBox"
                :style="styleObject"
                ref="tanBox"
                @scroll="gunDong()"
              >
                <ul
                  class="hintslist"
                  @mouseover="mouseOver"
                  @mouseleave="mouseLeave"
                >
                  <li
                    v-for="(item, index2) in scope.row.hints"
                    :key="index2"
                    class="hint"
                    :class="item == selected ? 'selected' : ''"
                    @click="fillInput(index2, scope.row)"
                  >
                    {{ item.employee_name_abbr }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="task_status_explaination" label="审批人" width="110" >
          <template slot-scope="scope">
          <div style="display: flex">
            <el-tag
              :key="index"
              v-for="(tag, index) in scope.row.roles_2"
              :disable-transitions="false"
              closable
              @close="handleClose2(tag, scope.row)"
              style="margin-left:10px"
            >
              {{tag.employee_name_abbr}}
            </el-tag>

            <div>
              <el-input
                style="position: relative; display: block"
                class="input-new-tag"
                v-if="scope.row.edit2"
                v-model="scope.row.zhanShi2"
                ref="input2"
                size="small"
                @keyup.native="getHintsList2(scope.row, $event)"
                @blur="shiqu2(scope.row)"
              >
              </el-input>
              <div v-else class="tianjia" @click="showInput2(scope.row)">+</div> 
              <div
                class="hintsBox"
                v-if="scope.row.showHintsBox2"
                :style="styleObject2"
                ref="tanBox2"
                @scroll="gunDong2()"
              >
                <ul
                  class="hintslist"
                  @mouseover="mouseOver"
                  @mouseleave="mouseLeave"
                >
                  <li
                    v-for="(item, index2) in scope.row.hints2"
                    :key="index2"
                    class="hint"
                    :class="item == selected2 ? 'selected' : ''"
                    @click="fillInput2(index2, scope.row)"
                  >
                    {{ item.employee_name_abbr }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        </el-table-column>
        <el-table-column prop="task_status_explaination" label="状态" width="110"> 
        <template slot-scope="scope" >
        <div class="selectKuang">
        <el-select  v-model="scope.row.mgmt_task_status" :class="[scope.row.mgmt_task_status == '10' ? 'xuanR': '', 
        scope.row.mgmt_task_status == '11'  ? 'xuanG': '',
         scope.row.mgmt_task_status == '12'  ? 'xuanY': ''
        ]"
        class="marginL2" @change="handleChangeTaskStatus(scope.row,$event)">
        <el-option
          v-for="item in mgmt_task_status_List"
          :key="item.mgmt_task_status"
          :label="item.task_status_explaination"
          :value="item.mgmt_task_status"
        >
        </el-option>
      </el-select>
          </div>
        </template>
        </el-table-column>
        <!-- <el-table-column
        prop="sort"
        label="复制"
        >
        <template slot-scope="scope">
          <el-button class="mybtn" v-if="scope.row.mgmt_task_id" @click="cope(scope.row,scope.$index)" type="text" size="small">复制</el-button>
          <el-button class="mybtn" v-show ="scope.row.niantie" @click="niantie(scope.row,scope.$index)" type="text" size="small">粘贴</el-button>
          
        </template>
      </el-table-column> -->
        <el-table-column label="操作"  width="180" style="text-align:right;">
         <template slot-scope="scope">
          <el-button class="mybtn1" v-if="scope.row.mgmt_task_id" @click="copys(scope.row,scope.$index)" type="text" size="small" icon="el-icon-document-copy"></el-button>
          <el-button v-if="scope.row.mgmt_task_id" class="mybtn1" type="text" size="small" @click= diaohuan(1,scope.$index,scope.row) icon="el-icon-top"></el-button>
          <el-button v-if="scope.row.mgmt_task_id" class="mybtn1" type="text" size="small" @click= diaohuan(2,scope.$index,scope.row) icon="el-icon-bottom"></el-button>
          <el-button
          v-if="scope.row.mgmt_task_id"
          size="mini"
          type="danger"  
          class="mybtn1"
          style="padding: 0"
          @click="handleDelete(scope.$index, scope.row)" icon="el-icon-close"></el-button>
        </template>
    </el-table-column>
      </el-table>
    </div>
    <!-- <div v-if="showWeekList == false" class="deftip">请先去创建周计划</div> -->
  </div>
</template>

<script>
import axios from "axios";
import { getBaseInfo } from "@/api/user";
import {
  getTaskOptionValue,
  gettasklistStrName,
  gettaskOptions,
  getpsheList,
  getuserInfo,
} from "@/lib/until";
import { formatDay, getDays } from "@/lib/weektime";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      projectList: [],
      project_id: "",
      weekplanList: [],
      week_plan_id: "",
      showWeekList: false,
      tableData: [],
      rowList: [],
      spanArr: [],
      position: 0,
      // 周表头
      weekDay: [],
      showClickIcon: "",
      row: "",
      column: "",
      base_info: "",
      cascaderKey: 0,
      createdWeekPlan: false,
      week_plan_name: "",
      selectedriqi: "",
      activeNo: -1,
      activeNo2: -1,
      employeeDeparts: [],
      selected: "",
      selected2: "",
      getShijiao: "",
      inputY: "",
      inputliTop: "",
      inputY2: "",
      inputliTop2: "",
      styleObject: {},
      styleObject2: {},
      kong: "",
      getInfo: {},
      mgmt_task_status_List: [],
      progress:"",
    };
  },
  mounted() {
    this.getInfo = getuserInfo();
    this.getEmployee_depart();
    this.getBaseInfo();
    this.getjieDuanstatus();
    this.getPorjectList();
   
  },
  watch: {
    //tableData: {
      
    //   deep: true,
    //   handler: function (newData) {
    //     console.log(newData); // 可以发现每次拖拽后数据发生了改变
    //   },
    // },
  },
  methods: {
    //计算百分比
    getprogress(newData) {
      let fenzi = 0;
      let fenmu = 0;
      for (let key in newData) {
        // scope.row.mgmt_task_status == '10'
        if (
          newData[key].mgmt_task_status == '10' ||
          newData[key].mgmt_task_status == '11'
        ) {
          fenmu += 1;
        }
        if (newData[key].mgmt_task_status == '11') {
          fenzi += 1;
        }
      }
      let jindu = parseInt((fenzi / fenmu) * 100);
      //return jindu;
      this.progress = jindu + "%";
    },
    handleChangeTaskStatus(row, el) {
      console.log(el,row);
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/task/update_mgmt_task.php", {
          mgmt_task_id: row.mgmt_task_id,
          mgmt_task_status: el,
        })
        .then((res) => {
          //console.log(res);
         // console.log(this.tableData);
          this.getprogress(this.tableData);
        });
    },
    //获取状态列表
    getjieDuanstatus() {
      axios
        .post(
          IPConfig.IP + "/kpi-management/mgmt/info/mgmt_task_status_info.php",
          {}
        )
        .then((res) => {
          console.log(res.data.mgmt_task_status);
          let mgmt_task_status = new Array();
          let zhiList = res.data.mgmt_task_status;
          zhiList.forEach((element) => {
            if (element.task_role == 3) {
              mgmt_task_status.push(element);
            }
          });
          this.mgmt_task_status_List = mgmt_task_status;
          //console.log(mgmt_task_status);
        });
    },
    diaohuan(el, index, row) {
      //1为上，2为下
      if (el == 1) {
        if (index == 0) {
          this.$message({
            message: "这是最上面的一个，不能在往上了",
            type: "error",
            duration: 1000,
          });
        } else {
          let nowZhi = index - 1;
          if (
            this.tableData[nowZhi].depart_id == this.tableData[index].depart_id
          ) {
            [
              this.tableData[nowZhi]["depart_task_order"],
              this.tableData[index]["depart_task_order"],
            ] = [
              this.tableData[index]["depart_task_order"],
              this.tableData[nowZhi]["depart_task_order"],
            ];
            [this.tableData[nowZhi], this.tableData[index]] = [
              this.tableData[index],
              this.tableData[nowZhi],
            ];

            let array = [];
            let obj = new Object();
            obj.mgmt_task_id = this.tableData[index].mgmt_task_id;
            obj.depart_task_order = this.tableData[index].depart_task_order;
            //console.log(obj);
            array.push(obj);
            let obj1 = new Object();
            obj1.mgmt_task_id = this.tableData[nowZhi].mgmt_task_id;
            obj1.depart_task_order = this.tableData[nowZhi].depart_task_order;
            //console.log(obj1);
            array.push(obj1);
            //console.log(array);

            axios
              .post(
                IPConfig.IP + "/kpi-management/mgmt/task/update_order.php",
                {
                  orders: array,
                }
              )
              .then((res) => {
                console.log(res);

                this.rowspan();
                this.$forceUpdate();
              });
          } else {
            this.$message({
              message: "不同部门不能换位置",
              type: "error",
              duration: 1000,
            });
          }
        }
      } else if (el == 2) {
        console.log(index, row);
        if (this.tableData.length - 1 == index) {
          this.$message({
            message: "这是最下面的一个，不能在往下了",
            type: "error",
            duration: 1000,
          });
        } else {
          let nowZhi = index + 1;
          if (
            this.tableData[nowZhi].depart_id == this.tableData[index].depart_id
          ) {
            [
              this.tableData[nowZhi]["depart_task_order"],
              this.tableData[index]["depart_task_order"],
            ] = [
              this.tableData[index]["depart_task_order"],
              this.tableData[nowZhi]["depart_task_order"],
            ];
            [this.tableData[nowZhi], this.tableData[index]] = [
              this.tableData[index],
              this.tableData[nowZhi],
            ];

            let array = [];
            let obj = new Object();
            obj.mgmt_task_id = this.tableData[index].mgmt_task_id;
            obj.depart_task_order = this.tableData[index].depart_task_order;
            //console.log(obj);
            array.push(obj);
            let obj1 = new Object();
            obj1.mgmt_task_id = this.tableData[nowZhi].mgmt_task_id;
            obj1.depart_task_order = this.tableData[nowZhi].depart_task_order;
            //console.log(obj1);
            array.push(obj1);
            //console.log(array);

            axios
              .post(
                IPConfig.IP + "/kpi-management/mgmt/task/update_order.php",
                {
                  orders: array,
                }
              )
              .then((res) => {
                console.log(res);

                this.rowspan();
                this.$forceUpdate();
              });
          } else {
            this.$message({
              message: "不同部门不能换位置",
              type: "error",
              duration: 1000,
            });
          }
        }
      }
    },
    copys(scope, index) {
      console.log(scope, index);
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/task/copy_mgmt_task.php", {
          from_id: scope.mgmt_task_id,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            let lieNumber = index + 1;
            // for (let key in this.tableData) {
            //   if (this.tableData[key].depart_id == scope.depart_id) {
            //     lieNumber += 1;
            //   }
            // }
            // console.log(lieNumber);

            let vms = Object.assign({}, scope);
            vms.depart_task_order = res.data.depart_task_order;
            vms.mgmt_task_id = res.data.mgmt_task_id;
            console.log(lieNumber, vms);

            this.tableData.splice(lieNumber, 0, vms);
            // this.tableData.push(vms);
            //console.log(this.tableData);
            this.rowspan();
            this.$forceUpdate();
          }
        });
    },
    cope(scope, index) {
      for (let key in this.tableData) {
        this.tableData[key].niantie = false;
      }
      for (let key in this.tableData) {
        if (this.tableData[key].depart_id == scope.depart_id) {
          this.tableData[key].niantie = true;
        }
      }
      this.$forceUpdate();
      // console.log(scope,index);
      this.copeContainer = scope;
      //  this.tabledatas.splice(index, 0,JSON.parse(JSON.stringify(val)))
    },
    niantie(scope, index) {
      console.log(scope, index);
      console.log(this.copeContainer);
      if (this.copeContainer["derpart_id"] == scope.derpart_id) {
        this.$confirm("是否复制?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            for (let key in this.tableData) {
              this.tableData[key].niantie = false;
            }

            let copy = Object.assign({}, this.copeContainer);

            scope.roles_1 = this.copyArr(copy["roles_1"]);
            scope.roles_2 = this.copyArr(copy["roles_2"]);
            scope.work_date = this.copyArr(copy["work_date"]);
            scope.comment = copy["comment"];
            scope.content = copy["content"];
            scope.task_id = copy["task_id"];
            scope.task_name_str = copy["task_name_str"];
            scope.task_priority = copy["task_priority"];
            scope.task_status_explaination = copy["task_status_explaination"];
            scope.value1 = copy["value1"];

            console.log(scope);
            this.tableData.splice(index, 1, scope);
            this.$forceUpdate();
            axios
              .post(
                IPConfig.IP + "/kpi-management/mgmt/task/copy_mgmt_task.php",
                {
                  from_id: this.copeContainer.mgmt_task_id,
                  to_id: scope.mgmt_task_id,
                }
              )
              .then((res) => {
                console.log(res);
                this.rowspan();
                this.$forceUpdate();
              });

            this.$message({
              type: "success",
              message: "复制成功!",
            });
          })
          .catch(() => {
            for (let key in this.tableData) {
              this.tableData[key].niantie = false;
            }
            this.$forceUpdate();
            this.$message({
              type: "info",
              message: "已取消复制",
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "不同部门不能复制",
        });
      }
    },
    rowDrop() {
      // 行拖拽
      const _this = this;
      const tbody2 = this.$refs.table.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );
      Sortable.create(tbody2, {
        handle: ".handle",
        animation: 150,
        ghostClass: "sortable-ghost",

        onChoose({ newIndex, oldIndex }) {
          //选择元素
          console.log(newIndex, oldIndex);
          this.spanArr = [];
          this.position = 0;
          for (let key in this.tableData) {
            this.spanArr.push(0);
          }
          this.$forceUpdate();
          // _this.column[_this.column.length - 1].fixed = false;
        },
        onUnchoose({ newIndex, oldIndex }) {
          // 取消选择元素
          console.log(newIndex, oldIndex);
        },
        onEnd({ newIndex, oldIndex }) {
          console.log(newIndex, oldIndex);
          // 拖拽完成
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
        },
      });

      // // 列拖拽
      // const tbody = this.$refs.table.$el.querySelector('.el-table__header-wrapper tr');
      // Sortable.create(tbody, {
      //   draggable: '.canDrag',
      //   animation: 150,
      //   onEnd({ newIndex, oldIndex }) {
      //     // 拖拽完成
      //     const currRow = _this.column.splice(oldIndex - 1, 1)[0];
      //     _this.column.splice(newIndex - 1, 0, currRow);
      //   },
      // });
    },
    drag(index, row) {
      // 此时找到的元素是要拖拽元素的父容器
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      console.log("tbody", tbody, index, row);
      // tbody.style.background = "red";
      const _this = this;
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: ".draggable .el-table__row",
        onEnd({ newIndex, oldIndex }) {
          console.log(newIndex, oldIndex);
          // const currRow = _this.tableData.splice(oldIndex, 1)[0];
          // _this.tableData.splice(newIndex, 0, currRow);
        },
      });
    },
    // 回车失去焦点 触发失去焦点事件
    carriageReturn(event, row) {
      event.target.blur();
    },
    doLayout() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    mouseOver() {
      //console.log(111);
      //判断是否在选则框内
      this.getShijiao = 1;
    },
    mouseLeave() {
      //console.log(222);
      this.getShijiao = "";
    },
    handleClose(tag, row) {
      //console.log(tag,row);
      axios
        .post(
          IPConfig.IP + "/kpi-management/mgmt/task/del_mgmt_task_role.php",
          {
            employee_id: tag.employee_id,
            mgmt_task_id: row.mgmt_task_id,
            task_role: 1,
          }
        )
        .then((res) => {
          console.log(res);
        });

      row.roles_1.splice(row.roles_1.indexOf(tag), 1);
    },
    handleClose2(tag, row) {
      axios
        .post(
          IPConfig.IP + "/kpi-management/mgmt/task/del_mgmt_task_role.php",
          {
            employee_id: tag.employee_id,
            mgmt_task_id: row.mgmt_task_id,
            task_role: 2,
          }
        )
        .then((res) => {
          console.log(res);
        });

      row.roles_2.splice(row.roles_2.indexOf(tag), 1);
    },
    sureSubmit(row) {
      console.log(row);
      console.log(this.employeeDeparts);
      var nameArr = [];
      for (let i in this.employeeDeparts) {
        if (
          this.employeeDeparts[i]["employee_name_abbr"] ==
            row.zhanShi.replace(/\s*/g, "") ||
          this.employeeDeparts[i]["employee_name"] ==
            row.zhanShi.replace(/\s*/g, "")
        ) {
          console.log(this.employeeDeparts[i].employee_id);
          let obj = {};
          obj.id = this.employeeDeparts[i].employee_id;
          obj.employee_name_abbr = this.employeeDeparts[i].employee_name_abbr;
          nameArr.push(obj);
        }
      }
      console.log(nameArr.length);
      if (nameArr.length > 0) {
        console.log(row.inputValue);
        if (typeof row.inputValue == "undefined" || row.inputValue == "") {
          row.inputValue = nameArr[0].id;
          row.zhanShi = nameArr[0].employee_name_abbr;
        }
        this.handleInputConfirm(row);
      } else {
        this.$message({
          message: "这名员工不存在",
          type: "error",
          duration: 1000,
        });
        row.edit = false;
        row.inputValue = "";
        row.zhanShi = "";
        row.showHintsBox = false;
      }
      this.activeNo = -1;
      this.selected = "";
      this.$forceUpdate();
    },
    sureSubmit2(row) {
      console.log(row);
      console.log(this.employeeDeparts);
      let nameArr2 = [];
      for (let i in this.employeeDeparts) {
        if (
          this.employeeDeparts[i]["employee_name_abbr"] ==
            row.zhanShi2.replace(/\s*/g, "") ||
          this.employeeDeparts[i]["employee_name"] ==
            row.zhanShi2.replace(/\s*/g, "")
        ) {
          console.log(this.employeeDeparts[i].employee_id);
          let obj = {};
          obj.id = this.employeeDeparts[i].employee_id;
          obj.employee_name_abbr = this.employeeDeparts[i].employee_name_abbr;
          nameArr2.push(obj);
        }
      }
      console.log(nameArr2.length);
      if (nameArr2.length > 0) {
        console.log(row.inputValue2);
        if (typeof row.inputValue2 == "undefined" || row.inputValue2 == "") {
          row.inputValue2 = nameArr2[0].id;
          row.zhanShi2 = nameArr2[0].employee_name_abbr;
        }
        this.handleInputConfirm2(row);
      } else {
        this.$message({
          message: "这名员工不存在",
          type: "error",
          duration: 1000,
        });
        row.edit2 = false;
        row.inputValue2 = "";
        row.zhanShi2 = "";
        row.showHintsBox2 = false;
      }
      this.activeNo2 = -1;
      this.selected2 = "";
      this.$forceUpdate();
    },
    getEmployee_depart() {
      return new Promise((resolve, reject) => {
        axios
          .post(IPConfig.IP + "/kpi-management/info/employee_departs.php", {})
          .then((res) => {
            //console.log(res.data.employee_departs);
            let employee_departs = res.data.employee_departs;
            for (let i in employee_departs) {
              employee_departs[i].employee_name_abbr =
                employee_departs[i]["employee_name"] +
                "-" +
                employee_departs[i]["depart_abbr"];
            }
            //console.log(employee_departs);
            this.employeeDeparts = employee_departs;
          });
      });
    },
    //当鼠标取消时
    shiqu(row) {
      console.log(row);
      if (this.getShijiao == "") {
        if (typeof row.zhanShi == "undefined" || row.zhanShi == "") {
          row.edit = false;
          row.zhanShi = "";
          row.showHintsBox = false;
          this.$forceUpdate();
        } else {
          this.sureSubmit(row);
        }
      }
    },
    shiqu2(row) {
      console.log(row);
      if (this.getShijiao == "") {
        if (typeof row.zhanShi2 == "undefined" || row.zhanShi2 == "") {
          row.edit2 = false;
          row.zhanShi2 = "";
          row.showHintsBox2 = false;
          this.$forceUpdate();
        } else {
          this.sureSubmit2(row);
        }
      }
    },
    //依据hints数组下标值填充输入框
    fillInput(index, row) {
      console.log(index);
      console.log(row);
      row.inputValue = row.hints[index].employee_id;
      row.zhanShi = row.hints[index].employee_name_abbr;
      this.handleInputConfirm(row);
    },
    fillInput2(index, row) {
      console.log(index);
      console.log(row);
      row.inputValue2 = row.hints2[index].employee_id;
      row.zhanShi2 = row.hints2[index].employee_name_abbr;
      this.handleInputConfirm2(row);
    },
    handleInputConfirm(row) {
      console.log(row.project_id);
      console.log(row.inputValue);
      console.log(row.roles_1);
      row.hints = [];
      row.showHintsBox = false;

      let inputValue = row.inputValue;

      if (inputValue) {
        let getObj = {};
        getObj.employee_id = row.inputValue;
        getObj.employee_name_abbr = row.zhanShi;
        row.roles_1.push(getObj);
        axios
          .post(
            IPConfig.IP + "/kpi-management/mgmt/task/add_mgmt_task_role.php",
            {
              employee_id: row.inputValue,
              mgmt_task_id: row.mgmt_task_id,
              task_role: 1,
            }
          )
          .then((res) => {
            console.log(res);
          });
      }
      row.edit = false;
      row.inputValue = "";
      row.zhanShi = "";
      this.activeNo = -1;
      this.selected = "";
      this.$forceUpdate();
    },
    handleInputConfirm2(row) {
      console.log(row.project_id);
      console.log(row.inputValue2);
      console.log(row.roles_2);
      row.hints2 = [];
      row.showHintsBox2 = false;

      let inputValue = row.inputValue2;

      if (inputValue) {
        let getObj = {};
        getObj.employee_id = row.inputValue2;
        getObj.employee_name_abbr = row.zhanShi2;
        row.roles_2.push(getObj);
        axios
          .post(
            IPConfig.IP + "/kpi-management/mgmt/task/add_mgmt_task_role.php",
            {
              employee_id: row.inputValue2,
              mgmt_task_id: row.mgmt_task_id,
              task_role: 2,
            }
          )
          .then((res) => {
            console.log(res);
          });
      }
      row.edit2 = false;
      row.inputValue2 = "";
      row.zhanShi2 = "";
      this.activeNo2 = -1;
      this.selected2 = "";
      this.$forceUpdate();
    },
    //获取候选列表
    getHintsList(row, $event) {
      console.log($event);
      console.log("发起查询请求");
      console.log(this.employeeDeparts);
      console.log(row);
      console.log(row.zhanShi);

      //按Enter键
      if ($event.keyCode == 13) {
        if (row.zhanShi == "" || typeof row.zhanShi == "undefined") {
        } else {
          this.sureSubmit(row);
        }
      } //Down键事件
      if ($event.keyCode == 40) {
        //划到最后一项的时候
        if (row.hints) {
          console.log(row.hints);
          let len = row.hints.length;
          if (len <= 0) {
            return;
          } else {
            this.activeNo += 1;
            console.log(this.activeNo);
            console.log(len);
            console.log(this.$refs.tanBox.scrollTop);
            // let shuzhi = 30;
            if (this.activeNo >= 6) {
              this.$refs.tanBox.scrollTop += 30;
              // this.gunDong(this.$refs.tanBox.scrollTop);
              // if(this.$refs.tanBox.scrollTop > 143){
              //   this.$refs.tanBox.scrollTop = 0;
              // }
            }

            if (this.activeNo > len - 1) {
              console.log("到底了");
              this.activeNo = 0;
              this.$refs.tanBox.scrollTop = 0;
              this.gunDong(this.$refs.tanBox.scrollTop);
              //console.log(row.hints[this.activeNo]);
              //return;
            }
            //console.log(this.activeNo);
            this.selected = row.hints[this.activeNo];
            row.inputValue = row.hints[this.activeNo].employee_id;
            row.zhanShi = row.hints[this.activeNo].employee_name_abbr;
            //console.log(row.hints[this.activeNo]);

            this.$forceUpdate();
          }
          console.log("向下事件");
        }
        return;
      }
      //Up键事件
      if ($event.keyCode == 38) {
        if (row.hints) {
          console.log(row.hints);
          let len = row.hints.length;
          if (len <= 0) {
            return;
          } else {
            this.activeNo -= 1;
            console.log(this.activeNo);
            console.log(len);
            if (this.activeNo < 0) {
              console.log("到顶了");
              this.activeNo = len - 1;
              this.$refs.tanBox.scrollTop = 1000;
            } else {
              this.$refs.tanBox.scrollTop -= 30;
            }
            //console.log(this.activeNo);

            this.gunDong(this.$refs.tanBox.scrollTop);
            this.selected = row.hints[this.activeNo];
            row.inputValue = row.hints[this.activeNo].employee_id;
            row.zhanShi = row.hints[this.activeNo].employee_name_abbr;
            //console.log(row.hints[this.activeNo]);
            this.$forceUpdate();

            // this.selected =
            // row.inputValue = "";
          }
          console.log("向上事件");
        }
        return;
      } else {
        if (row.zhanShi != "" && typeof row.zhanShi != "undefined") {
          let findZhanshi = row.zhanShi.replace(/\s*/g, "");
          let getpersonList = [];
          for (let i in this.employeeDeparts) {
            if (
              this.employeeDeparts[i]["employee_name"].indexOf(findZhanshi) !=
              -1
            ) {
              let obj = {};
              obj.employee_id = this.employeeDeparts[i]["employee_id"];
              obj.employee_name = this.employeeDeparts[i]["employee_name"];
              var name_depart =
                this.employeeDeparts[i]["employee_name"] +
                "-" +
                this.employeeDeparts[i]["depart_abbr"];
              obj.employee_name_abbr = name_depart;
              //console.log(this.employeeDeparts[i].employee_name);
              getpersonList.push(obj);
            }
          }
          //var arr = ["选项1", "选项2", "选项3", "选项4", "haha"]; //模拟后台返回的数据
          console.log(getpersonList);

          row.showHintsBox = true;
          if (this.inputY - this.inputliTop <= 280) {
            console.log("该朝上了");
            this.styleObject.bottom = 45 + "px";
          } else {
            this.styleObject = {};
          }
          row.hints = getpersonList;
          this.$forceUpdate();
        } else {
          this.$nextTick(() => {
            this.$forceUpdate();
            row.showHintsBox = false;
            row.hints = [];
          });
        }
      }
    },
    getHintsList2(row, $event) {
      console.log($event);
      console.log("发起查询请求");
      console.log(this.employeeDeparts);
      console.log(row);
      console.log(row.zhanShi2);

      //按Enter键
      if ($event.keyCode == 13) {
        if (row.zhanShi2 == "" || typeof row.zhanShi2 == "undefined") {
        } else {
          this.sureSubmit2(row);
        }
      } //Down键事件
      if ($event.keyCode == 40) {
        //划到最后一项的时候
        if (row.hints2) {
          console.log(row.hints);
          let len = row.hints2.length;
          if (len <= 0) {
            return;
          } else {
            this.activeNo2 += 1;
            console.log(this.activeNo2);
            console.log(len);
            console.log(this.$refs.tanBox2.scrollTop);
            // let shuzhi = 30;
            if (this.activeNo2 >= 6) {
              this.$refs.tanBox2.scrollTop += 30;
              // this.gunDong(this.$refs.tanBox.scrollTop);
              // if(this.$refs.tanBox.scrollTop > 143){
              //   this.$refs.tanBox.scrollTop = 0;
              // }
            }

            if (this.activeNo2 > len - 1) {
              console.log("到底了");
              this.activeNo2 = 0;
              this.$refs.tanBox2.scrollTop = 0;
              this.gunDong2(this.$refs.tanBox2.scrollTop);
              //console.log(row.hints[this.activeNo]);
              //return;
            }
            //console.log(this.activeNo);
            this.selected2 = row.hints2[this.activeNo2];
            row.inputValue2 = row.hints2[this.activeNo2].employee_id;
            row.zhanShi2 = row.hints2[this.activeNo2].employee_name_abbr;
            //console.log(row.hints[this.activeNo]);

            this.$forceUpdate();
          }
          console.log("向下事件");
        }
        return;
      }
      //Up键事件
      if ($event.keyCode == 38) {
        if (row.hints2) {
          console.log(row.hints2);
          let len = row.hints2.length;
          if (len <= 0) {
            return;
          } else {
            this.activeNo2 -= 1;
            console.log(this.activeNo2);
            console.log(len);
            if (this.activeNo2 < 0) {
              console.log("到顶了");
              this.activeNo2 = len - 1;
              this.$refs.tanBox2.scrollTop = 1000;
            } else {
              this.$refs.tanBox2.scrollTop -= 30;
            }
            //console.log(this.activeNo);

            this.gunDong2(this.$refs.tanBox2.scrollTop);
            this.selected2 = row.hints2[this.activeNo2];
            row.inputValue2 = row.hints2[this.activeNo2].employee_id;
            row.zhanShi2 = row.hints2[this.activeNo2].employee_name_abbr;
            //console.log(row.hints[this.activeNo]);
            this.$forceUpdate();

            // this.selected =
            // row.inputValue = "";
          }
          console.log("向上事件");
        }
        return;
      } else {
        if (row.zhanShi2 != "" && typeof row.zhanShi2 != "undefined") {
          let findZhanshi = row.zhanShi2.replace(/\s*/g, "");
          let getpersonList = [];
          for (let i in this.employeeDeparts) {
            if (
              this.employeeDeparts[i]["employee_name"].indexOf(findZhanshi) !=
              -1
            ) {
              let obj = {};
              obj.employee_id = this.employeeDeparts[i]["employee_id"];
              obj.employee_name = this.employeeDeparts[i]["employee_name"];
              var name_depart =
                this.employeeDeparts[i]["employee_name"] +
                "-" +
                this.employeeDeparts[i]["depart_abbr"];
              obj.employee_name_abbr = name_depart;
              //console.log(this.employeeDeparts[i].employee_name);
              getpersonList.push(obj);
            }
          }
          //var arr = ["选项1", "选项2", "选项3", "选项4", "haha"]; //模拟后台返回的数据
          console.log(getpersonList);

          row.showHintsBox2 = true;
          if (this.inputY2 - this.inputliTop2 <= 280) {
            console.log("该朝上了");
            this.styleObject2.bottom = 45 + "px";
          } else {
            this.styleObject2 = {};
          }
          row.hints2 = getpersonList;
          this.$forceUpdate();
        } else {
          this.$nextTick(() => {
            this.$forceUpdate();
            row.showHintsBox2 = false;
            row.hints2 = [];
          });
        }
      }
    },
    showInput(row) {
      console.log(row);
      if (typeof row.mgmt_task_id == "undefined") {
        this.$message({
          message: "阶段和内容不能为空",
          type: "error",
          duration: 1000,
        });
      } else {
        this.$set(row, "edit", true);
        row.edit = true;
        // this.inputVisible = true;
        this.$nextTick((_) => {
          this.$refs["input1"].$refs.input.focus();
          this.inputliTop =
            this.$refs["input1"].$refs.input.getBoundingClientRect().bottom;
          this.inputY = document.body.clientHeight;
          // console.log(this.$refs[zhiInput].$refs.input.getBoundingClientRect().bottom)
          // console.log( document.body.clientWidth);
          // console.log( document.body.clientHeight);
        });
      }
    },
    showInput2(row) {
      console.log(row);
      if (typeof row.mgmt_task_id == "undefined") {
        this.$message({
          message: "阶段和内容不能为空",
          type: "error",
          duration: 1000,
        });
      } else {
        this.$set(row, "edit2", true);
        row.edit2 = true;
        // this.inputVisible = true;
        this.$nextTick((_) => {
          this.$refs["input2"].$refs.input.focus();
          this.inputliTop2 =
            this.$refs["input2"].$refs.input.getBoundingClientRect().bottom;
          this.inputY2 = document.body.clientHeight;
          // console.log(this.$refs[zhiInput].$refs.input.getBoundingClientRect().bottom)
          // console.log( document.body.clientWidth);
          // console.log( document.body.clientHeight);
        });
      }
    },
    //判断滚动条的高度
    gunDong(el) {
      //console.log(this.$refs.tanBox.scrollTop);
      if (el) {
        this.$refs.tanBox.scrollTop = el;
      }
    },
    gunDong2(el) {
      //console.log(this.$refs.tanBox.scrollTop);
      if (el) {
        this.$refs.tanBox2.scrollTop = el;
      }
    },
    //输入框失去焦点时
    inputBlur(row) {
      console.log("传进来的值", row);
      this.isInputBlur = false;
      this.updateContents(row);
      console.log(row.mgmt_task_id);
    },
    createdPlan() {
      this.createdWeekPlan = true;
      this.week_plan_name = "";
      this.selectedriqi = [];
    },
    weekPlanSrue() {
      if (this.week_plan_name != "" && this.selectedriqi.length > 0) {
        console.log(this.week_plan_name);
        console.log(this.selectedriqi);
        let strDate = formatDay(this.selectedriqi[0]);
        let endDate = formatDay(this.selectedriqi[1]);
        console.log(strDate);
        console.log(endDate);
        axios
          .post(IPConfig.IP + "/kpi-management/mgmt/plan/add_mgmt_plan.php", {
            plan_name: this.week_plan_name,
            project_id: this.project_id,
            begin_date: strDate,
            end_date: endDate,
          })
          .then((res) => {
            console.log(res);
            if (res.data.errcode == 0) {
              this.$message({
                message: "创建成功",
                type: "success",
                duration: 1000,
              });
              this.createdWeekPlan = false;
              this.handleChangeProject();
            } else {
              this.$message({
                message: "创建失败",
                type: "error",
                duration: 1000,
              });
            }
          });
      } else {
        this.$message({
          message: "填写完整的信息",
          type: "error",
          duration: 1000,
        });
      }
    },
    //新建记录
    createdPhase(row) {
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/task/add_mgmt_task.php", {
          content: row.content,
          task_id: row.value1[1],
          project_id: this.project_id,
          mgmt_plan_id: this.week_plan_id,
          depart_id: row.depart_id,
        })
        .then((res) => {
          console.log(res);
          if (res.data.errcode == 0) {
            row.mgmt_task_id = res.data.mgmt_task_id;
            this.$forceUpdate();
          }
        });
    },
    //更新记录
    updatePhase(row) {
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/task/update_mgmt_task.php", {
          mgmt_task_id: row.mgmt_task_id,
          task_id: row.value1[1],
        })
        .then((res) => {
          console.log(res);
          if (res.data.errcode == 0) {
            this.$forceUpdate();
          }
        });
    },
    updateContents(row) {
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/task/update_mgmt_task.php", {
          mgmt_task_id: row.mgmt_task_id,
          content: row.content,
        })
        .then((res) => {
          console.log(res);
          if (res.data.errcode == 0) {
            this.$forceUpdate();
          }
        });
    },
    changePahse(el, row) {
      console.log(el, row);
      this.updatePhase(row);
    },
    //获取部门列表
    getBaseInfo() {
      getBaseInfo().then((res) => {
        this.base_info = res;
        console.log(res.depart_list);
        let depart_list = res.depart_list;
        let derList = [];
        for (let key in depart_list) {
          if (depart_list[key].has_project_phases == 1) {
            derList.push(depart_list[key]);
          }
        }
        this.depart_list = derList;
      });
    },
    //展示颜色
    showColor() {
      setTimeout(() => {
        const el = document.getElementsByClassName(
          "el-table--enable-row-hover"
        )[0];
        // console.log(el)
        let newName = el.getAttribute("class");
        // console.log( newName)
        newName = newName.replace("el-table--enable-row-hover", "");
        // console.log( newName)
        el.setAttribute("class", newName);
        // console.log(el)
      }, 60);
    },
    //获取项目列表数据
    getPorjectList() {
      console.log(this.getInfo.employee_id);
      axios
        .post(
          IPConfig.IP + "/kpi-management/mgmt/project/sel_project_list.php",
          {
            employee_id: this.getInfo.employee_id,
          }
        )
        .then((res) => {
          console.log(res.data.project_results);
          this.projectList = res.data.project_results;
          if (this.projectList.length > 0) {
            this.project_id = this.projectList[0].project_id;
            this.getWeekPlan();
          }
        });
    },
    //项目改变查询
    handleChangeProject(el) {
      console.log(this.project_id);
      this.week_plan_id = "";
      this.getWeekPlan();
    },
    //周计划改变查询
    handleChangeWeek() {
      this.getPlanDetail();
    },
    //获取周计划的列表；
    getWeekPlan() {
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/plan/sel_mgmt_plan.php", {
          project_id: this.project_id,
        })
        .then((res) => {
          console.log(res.data.plan_results);
          this.weekplanList = res.data.plan_results;
          if (this.weekplanList.length > 0) {
            this.week_plan_id = this.weekplanList[0].mgmt_plan_id;
            this.showWeekList = true;
            this.getPlanDetail();
          } else {
            this.showWeekList = false;
          }
        });
    },
    //深拷贝
    copyArr(arr) {
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;
    },
    deepClone(obj) {
      let objClone = Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === "object") {
        for (let key in obj) {
          if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = deepClone(obj[key]);
          } else {
            objClone[key] = obj[key];
          }
        }
      }
      return objClone;
    },
    //查找周计划列表

    getPlanDetail() {
      // mgmt_plan_id: this.week_plan_id,
      //mgmt_plan_id: 6,
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/plan/plan_detail.php", {
          mgmt_plan_id: this.week_plan_id,
        })
        .then((res) => {
          console.log(res.data.mgmt_tasks);
          console.log(res.data.mgmt_tasks.date_list);
          let weekDay = res.data.mgmt_tasks.date_list;
          let getWeekDay = [];
          //初始work_date的个数为0；
          let intWorkList = [];
          for (let i = 0; i < weekDay.length; i++) {
            //console.log(weekDay[i][0]);
            intWorkList.push(0);
            let riqi = weekDay[i][0];
            let tian = weekDay[i][1];
            riqi = riqi.split("-");
            let Obj = {
              label: "",
              property: "work_date",
              tian: "",
              ri: "",
              qi: "",
              dayname: "",
            };
            let zhi = `${tian} | ${riqi[2]} | ${riqi[1]}月`;
            Obj.label = zhi;
            Obj.tian = tian;
            Obj.ri = riqi[2];
            Obj.qi = riqi[1];
            Obj.dayname = weekDay[i][0];
            getWeekDay.push(Obj);
          }
          console.log(getWeekDay);
          this.weekDay = getWeekDay;
          let gettableData = res.data.mgmt_tasks.mgmt_tasks;
          this.getprogress(gettableData);
          //this.getprogress(gettableData);
          getBaseInfo().then((jieguo) => {
            this.base_info = jieguo;
            this.gettaskList(gettableData, jieguo);
          });
        });
    },
    //获取部门名字
    gettaskList(gettableData, base_info) {
      if (gettableData.length <= 0) {
      } else {
        let tableDataList = [];
        for (var i = 0; i < gettableData.length; i++) {
          let vms = gettableData[i];
          //获取部门名字

          //获取阶段名字
          for (let key in base_info.project_list) {
            if (vms.project_id == key) {
              vms["xiangmucn"] = base_info.project_list[key].project_name_cn;
            }
          }

          getpsheList(vms).then((res) => {
            //console.log(vms);
            vms["chioes"] = gettaskOptions(vms.depart_id, base_info, res);
            let chioseList = vms["chioes"];
            vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
            //console.log(vms);
            var taskoptions = base_info.depart_all_task_list[vms.depart_id];
            var scopeName = [];
            Object.assign(scopeName, vms["value1"]);
            if (scopeName.length > 0) {
              vms["task_name_str"] = gettasklistStrName(
                vms.task_id,
                scopeName,
                taskoptions
              );
            } else {
              vms["task_name_str"] = vms.task_id;
            }
            tableDataList.push(vms);
            tableDataList.sort(function (a, b) {
              return a.depart_id - b.depart_id;
            });
            this.tableData = tableDataList;
            //console.log(this.tableData);
            this.rowspan();
            this.$forceUpdate();
          });
        }
      }
    },
    //行单击
    cellclick(row, column, cell, event) {
      // console.log(row,column,cell,event)
      //console.log(row.mgmt_task_id);
      //console.log(column.property);
      var mgmt_task_id = row.mgmt_task_id;
      var week_data = column.property;

      if (column.label == "日期") {
        let geziKey = row.work_date;
        let geziValue = column.index;
        if (geziKey[geziValue] == 1) {
          geziKey[geziValue] = 0;
          axios
            .post(
              IPConfig.IP + "/kpi-management/mgmt/task/del_mgmt_task_date.php",
              {
                mgmt_task_id: mgmt_task_id,
                work_date: week_data,
              }
            )
            .then((res) => {
              //console.log(res);
            });
        } else if (geziKey[geziValue] == 0) {
          geziKey[geziValue] = 1;
          axios
            .post(
              IPConfig.IP + "/kpi-management/mgmt/task/add_mgmt_task_date.php",
              {
                mgmt_task_id: mgmt_task_id,
                work_date: week_data,
              }
            )
            .then((res) => {
              //console.log(res);
            });
        }
        //console.log(geziKey);
        //console.log(column.index);
        this.$forceUpdate();
      }
      // if (column.label === "内容") {
      //   this.isInputBlur = true;
      //   this.$forceUpdate();
      // } else {
      //   this.isInputBlur = false;
      //   this.$forceUpdate();
      // }
    },

    cellClassName({ row, column, rowIndex, columnIndex }) {
      //console.log(row, column, rowIndex, columnIndex);
      row.index = rowIndex;
      //column.index = columnIndex;
      return "yangshi";
    },

    //修改单元格样式的方法 // 动态设置颜色
    addClass({ row, column, rowIndex, columnIndex }) {
      // console.log(column);
      // console.log(row);
      // console.log(rowIndex);
      // console.log(columnIndex);

      // if (column.label === "状态") {
      //   if (row.task_status_explaination == "未完成") {
      //     return "background: #ffffff;padding: 4px 0";
      //   } if (row.task_status_explaination == "已完成") {
      //     return "background: #CCFF99;padding: 4px 0";
      //   } if (row.task_status_explaination == "取消") {
      //     return "background: #D7D7D7;padding: 4px 0";
      //   }
      // }
      if (column.label === "部门") {
        if (row.depart_name == "市场") {
          return "background: #f59a23;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "造价") {
          return "background:#999933;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "项目") {
          return "background:#006699;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "创意") {
          return "background:#666699;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "施工设计") {
          return "background:#CC6633;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "媒体") {
          return "background:#009999;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "研发") {
          return "background: #02a7f0;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "采购") {
          return "background: #CC3399;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "系统集成") {
          return "background: #FF6666;color:#fff;padding: 4px 0";
        }
      }
      if (column.label == "日期") {
        let geziKey = row.work_date;
        let geziValue = column.index;
        //console.log(geziKey);
        //console.log(column.index);
        if (geziKey[geziValue] == 1) {
          return "background-color: red;padding: 4px 0";
        } else {
          return "background-color: #fff;padding: 4px 0";
        }
      } else {
        return "background:#fff;padding: 4px 0";
      }
    },

    dianji(el, scope) {
      //console.log(el, scope);
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/task/add_mgmt_task.php", {
          project_id: el.project_id,
          mgmt_plan_id: this.week_plan_id,
          depart_id: el.depart_id,
        })
        .then((res) => {
          //console.log(res);
          if (res.data.errcode == 0) {
            let getIndex = el.index;
            let worklength = el.work_date.length;
            // //console.log(worklength);
            let workArray = [];
            for (let i = 0; i < worklength; i++) {
              workArray.push(0);
            }
            let lieNumber = 0;
            for (let key in this.tableData) {
              if (this.tableData[key].depart_id == el.depart_id) {
                lieNumber += 1;
              }
            }
            // console.log(lieNumber);
            getIndex = getIndex + lieNumber;
            let obj = {};
            obj.roles_1 = [];
            obj.roles_2 = [];
            obj.comment = null;
            obj.content = "";
            obj.depart_id = el.depart_id;
            obj.depart_name = el.depart_name;
            obj.work_date = workArray;
            obj.project_id = el.project_id;
            obj.mgmt_task_id = res.data.mgmt_task_id;
            obj.depart_task_order = res.data.depart_task_order;
            let vms = obj;
            getpsheList(vms).then((res) => {
              //console.log(vms);
              vms["chioes"] = gettaskOptions(
                vms.depart_id,
                this.base_info,
                res
              );
              let chioseList = vms["chioes"];
              vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
              //console.log(vms);
              var taskoptions =
                this.base_info.depart_all_task_list[vms.depart_id];
              var scopeName = [];
              Object.assign(scopeName, vms["value1"]);
              if (scopeName.length > 0) {
                vms["task_name_str"] = gettasklistStrName(
                  vms.task_id,
                  scopeName,
                  taskoptions
                );
              } else {
                vms["task_name_str"] = vms.task_id;
              }
              this.tableData.splice(getIndex, 0, vms);
              // this.tableData.push(vms);
              //console.log(this.tableData);
              this.rowspan();
              this.$forceUpdate();
            });
          }
        });
    },
    rowspan() {
      this.spanArr = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.tableData[index].depart_id ===
            this.tableData[index - 1].depart_id
          ) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      });
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //表格合并行
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    handleDelete(index, row) {
      //mgmt_task_id
      console.log(index, row);
      let getZhi = this.getRepeatNum(this.tableData, row);
      console.log(getZhi);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (getZhi <= 1) {
            console.log(row);
            let aIndex = row.index;
            let week_list = [];
            for (let key in row.work_date) {
              week_list.push(0);
            }
            console.log(week_list);
            let obj = {};
            obj.chioes = row.chioes;
            obj.value1 = [];
            obj.comment = row.comment;
            obj.content = "";
            obj.depart_id = row.depart_id;
            obj.depart_name = row.depart_name;
            obj.depart_abbr = row.depart_abbr;
            obj.project_id = row.project_id;
            obj.roles_1 = [];
            obj.roles_2 = [];
            obj.work_date = week_list;
            obj.xiangmucn = row.xiangmucn;
            this.tableData.splice(index, 1);
            axios
              .post(
                IPConfig.IP + "/kpi-management/mgmt/task/del_mgmt_task.php",
                {
                  mgmt_task_id: row.mgmt_task_id,
                }
              )
              .then((res) => {
                console.log(res);
                this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 1000,
                });
                this.dianji(row);
                // this.tableData.splice(aIndex, 0, obj);
                this.rowspan();
                this.$forceUpdate();
              });
          } else {
            axios
              .post(
                IPConfig.IP + "/kpi-management/mgmt/task/del_mgmt_task.php",
                {
                  mgmt_task_id: row.mgmt_task_id,
                }
              )
              .then((res) => {
                console.log(res);
                this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 1000,
                });
                this.tableData.splice(index, 1);
                this.rowspan();
                this.$forceUpdate();
              });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //获取数组里的某个字段的个数
    getRepeatNum(arr, math) {
      let zhi = 0;
      for (let i = 0, l = arr.length; i < l; i++) {
        let item = arr[i];
        if (item.depart_id == math.depart_id) {
          zhi += 1;
        }
      }
      return zhi;
    },
  },
};
</script>
<style scoped>
.xuanR >>> .el-input__inner {
   color:red;
}
.xuanG >>> .el-input__inner {
   color:green;
}
.xuanY >>> .el-input__inner {
   color:gray;
}
.mybtn:focus {
  color: red;
}
.mybtn1:active {
  color: red;
}
.mybtn1 {
  font-size: 14px !important;
}
.sortable-ghost {
  border: aqua 10px solid !important;
}
.handle,
.canDrag {
  cursor: move;
}

::v-deep .hover-row > td {
  background-color: #fff !important;
}

::v-deep .sortable-chosen > td {
  background-color: red !important;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fff;
}
.tianjia {
  height: 32px;
  width: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  cursor: pointer;
}
.lableName {
  width: 15%;
  line-height: 40px;
}
.xianshikuang {
  display: flex;
  padding: 10px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 80px;
  margin-left: 10px;
  vertical-align: bottom;
}
[v-cloak] {
  display: none;
}

.hintsbox-mark {
  position: relative;
}

.hintsbox-mark input {
  width: 250px;
}

.hintsBox {
  position: absolute;
  z-index: 100000;
  /* top:264px;
  left:538px; */
  width: 120px;
  border: 1px solid #ddd;
  border-radius: 5%;
  background-color: skyblue;
  max-height: 200px;
  overflow-y: scroll;
}

/*滚动条样式*/
.hintsBox::-webkit-scrollbar {
  width: 1px;
  height: 4px;
}
.hintsBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.hintsBox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.hintslist .hint {
  padding: 4px 4px;
}

.hintslist .hint:hover {
  background-color: #ddd8e5;
  cursor: pointer;
}

.hintslist .hint.active {
  background-color: #ddd8e5;
}
.selected {
  background-color: #ddd8e5 !important;
}
.selectKuang >>> .el-input__inner {
  border: 0;
}
/* 利用穿透，设置input边框隐藏 */
.inputDeep >>> .el-input__inner {
  border: 0;
}
/* 如果你的 el-input type 设置成textarea ，就要用这个了 */
.inputDeep >>> .el-textarea__inner {
  border: 0;
  min-height: 24px;
  resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
}
.mart3 {
  margin-top: 30px;
}
.xianshikuang {
  display: flex;
  align-items: center;
}
.lableName {
  width: 100px;
}
.yangshi {
  padding: 0 !important;
  text-align: center !important;
  color: #000;
  height: 40px !important;
}
.deftip {
  text-align: center;
  padding: 30px;
  color: red;
}
.withe {
  background: #fff;
}
.blue {
  background: #02a7f0;
}
.red {
  background: red;
}
.cell-grey {
  background: #f59a23;
}
.el-table th > .cell {
  padding: 0 !important;
  text-align: center;
}
.table >>> .cell {
  padding: 0 !important;
  text-align: center;
}
.daKuang {
  display: flex !important;
  flex-direction: column;
}
.waiKuang {
  height: 30px;
  font-size: 10px;
}
.riqi {
  font-size: 14px;
  padding: 10px 0;
}
.yuefen {
  font-size: 12px;
  font-weight: 500;
}
.jindukuang {
  width: 15%;
  height: 38px;
  font-weight: 500;
  border: 1px solid #dcdfe6;
  color: #606266;
  line-height: 38px;
  text-align: center;
}
.marginL2 {
  margin-left: 2%;
}
.addBtn {
  width: 100%;
  /* height: 30px; */
  font-size: 20px;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Xinrenwu/index.vue